import { useState, useEffect } from "react";
import { X } from "lucide-react";
import eidImage from "@/assets/eid-mubarak.png";

const EID_END_DATE = new Date("2026-03-29T23:59:59"); // 10 days from March 19

const EidMubarakBanner = () => {
  const [dismissed, setDismissed] = useState(false);
  const [isExpired, setIsExpired] = useState(false);

  useEffect(() => {
    if (new Date() > EID_END_DATE) {
      setIsExpired(true);
    }
  }, []);

  if (isExpired || dismissed) return null;

  return (
    <div className="relative w-full">
      <button
        onClick={() => setDismissed(true)}
        className="absolute top-3 right-3 z-10 bg-black/40 hover:bg-black/60 text-white rounded-full p-1.5 transition-colors"
        aria-label="Dismiss"
      >
        <X className="w-4 h-4" />
      </button>
      <img
        src={eidImage}
        alt="Eid Mubarak - Arabian Al Waha wishes you peace, prosperity and success"
        className="w-full h-auto block"
      />
    </div>
  );
};

export default EidMubarakBanner;
